"use strict";
(function (global) {

  /**
  * Редактор для ячейки с реквизитом "Ссылка на документ".  
  * @class WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor
  * @extends WebAccess.components.dataViews.gridPlugins._editors.StringEditor
  * @since 5.5.0.1000
  */
  global.BaseObjectSelectEditor = global.StringEditor.extend({
    _renderer: null,
    _wrapper: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (args) {
      var me = this;
      me._super(args);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Рендеринг и добавление контрола реквизита в ячейку грида
    * @since 5.5.0.1000
    * @method WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor#render
    */
    render: function () {
      var me = this;

      me._data.id = me.id,
      me._data.defaultValue = me._displayValue;
      me._data.hiddenInputValue = me._value; //если выбор множествeнный то тут должны быть перечисления id через ";"
      me._data.selectedRecordID = me._value;

      //Для отключения старой логики работы ведущих/ведомых. Новая находится в Core.cards.initLeaderDrivenLogic.
      me._data.leaderRequisites = '[]';
      me._data.drivenRequisites = '[]';

      // Означиваем номер строки детально раздела в контексте вызова. Тут а не в конструкторе, т.к. в базовом в конструкторе вызывается render.
      var settings = $.parseJSON(me._data.settings);

      // Устанавливаемость признак что значение есть, т.к. для детального раздела он из вне передается некорректный.
      settings.selected = ('' + me._data.selectedRecordID) !== '';

      var queryContext = $.parseJSON(settings.queryContext);
      if (queryContext) {
        queryContext.detailRecordId = +me._row.id;
        settings.queryContext = $.toJSON(queryContext);
      }
      me._data.settings = $.toJSON(settings);

      me._renderer = me._createRenderer();
      if (me._renderer) {
        me._renderer.renderAsync(me._data).done(function (html) {
          me._jContainer.html('<div class="objectSelectEditor editor" tabindex="1">' + html + '</div>');
          me._jContainer.find('input.input').addClass('noBorder');

          me._getWrapper().bind('change', function (e, i, values) {
            me._updateData(me._row, values);
          });

          me._jInput = $('#' + me.id);

          // Для планшетов и сматфонов отключаем клавиатурную навигацию.
          if (!WA.ENV.isTouch()) {
            me.initKeyNavigation();
          }

          me.renderState.resolve();
        });
      } else {
        me.renderState.reject();
      }
      return me.renderState;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создает рендерер.
    * @private
    */
    _createRenderer: function () {
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Инициализация событий отвечающих за клавиатурную навигацию по ячейке
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#initKeyNavigation
    * @since 5.5.0.1000     
    */
    initKeyNavigation: function () {
      var me = this;
      var c = $.ui.keyCode;
      var jEditContainer = me._jContainer.find('.editor');

      var isAllTextSelected = function (jInput) { return me.isFocused(); }
      var hasText = function (jInput) { return !!jInput.val(); }
      var hasNoValue = function () { return !me._getWrapper().getValue() }
      var leaveOut = function (e) { };
      var stayHere = function (e) { e.stopImmediatePropagation(); }
      var disableSlickOnEnter = function (e) { e.stopImmediatePropagation(); }

      var passKeyToInput = function (key) {
        var press = jQuery.Event("keydown");
        press.ctrlKey = false;
        press.which = key;
        me._jInput.trigger(press);
      }

      var selectAllText = function () {
        me._jInput.blur();
        me.focus();
        jEditContainer.focus();
      }

      var focusToInput = function () {
        me.unFocus();
        me._jInput.focus();
      }

      //При нажатии на enter переводим фокус на инпут
      jEditContainer.on("keydown.nav", function (e) {
        var key = e.which
        if (key === c.ENTER) {
          if (isAllTextSelected() || hasNoValue()) {
            focusToInput();
            disableSlickOnEnter(e);
          }
        }
      })

      //Если выделен весь текст, то при вводе пробрасываем событие в инпут и фокус тоже
      jEditContainer.on("keydown.nav", function (e) {

        if (!isAllTextSelected()) return;
        var key = e.which
        if (key === c.BACKSPACE || key === c.DELETE) {
          if (!me._getWrapper().isDisabled()) {
            me._getWrapper().clear(true);
          }
        }

        var ignoredKeys = [c.LEFT, c.RIGHT, c.DOWN, c.CONTROL, c.UP, c.TAB, c.ESCAPE, c.SHIFT, c.PAGE_UP, c.PAGE_DOWN, c.END, c.CAPS_LOCK, c.ENTER];
        if (ignoredKeys.indexOf(key) === -1 && !e.shiftKey && !e.metaKey && !e.ctrlKey) {

          //чтобы при нажатии на alt+down поле не очищалось а работала выпадайка вниз
          if (!e.altKey && !me._getWrapper().isDisabled()) {
            me._getWrapper().clear();
          }

          focusToInput();
          passKeyToInput(key);
        }
      }).focus().select();

      //Если нажимаем на enter находясь в инпуте - убираем фокус с него и выделяем весь текст
      me._jInput.bind("keydown.nav", function (e) {
        var key = e.which;
        if (key === c.ENTER) {
          selectAllText();
          disableSlickOnEnter(e);
        }

        if (e.keyCode === c.LEFT || e.keyCode === c.RIGHT) {
          //if (hasNoValue()) {
          leaveOut(e);
          /*} else {
            stayHere(e);
          } */
        }
      });

      //При клике в инпут, надо снимать выделение с текста
      me._jInput.on('focus.nav', function () {
        me.unFocus();
      });

      //Инициализация фокуса
      if (hasNoValue()) {
        focusToInput();
      } else {
        selectAllText();
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить фокус на поле ввода(а если честно, то на спан с текстом)
    * @method WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor#focus
    * @since 5.5.0.1000     
    */
    focus: function () {
      this._getSelectedItemElements().addClass('selectedText');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    isFocused: function () {
      return this._getSelectedItemElements().hasClass('selectedText');
    },

    /**
    * Получить объект-обертку над контролом реквизита, с необходимыми методами типа getValue
    * @since 5.5.0.1000
    * @method WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor#unFocus
    */
    unFocus: function () {
      this._getSelectedItemElements().removeClass('selectedText');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает выбранные элементы.
    * @since 5.5.0.1000
    * @private
    * @method WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor#_getSelectedItemElements
    */
    _getSelectedItemElements: function () {
      return this._jContainer.find('.rs_SelItems span');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить объект-обертку над контролом реквизита, с необходимыми методами типа getValue
    * @since 5.5.0.1000
    * @method WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor#_getWrapper
    * @private
    */
    _getWrapper: function () {
      var me = this;
      if (!!me._wrapper) return me._wrapper;
      var parentCurrent = me._gridComp._parent.settings.current;
      return me._wrapper = me._createWrapper(parentCurrent);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Создает объект-обертку над контролом реквизита, с необходимыми методами типа getValue
     * @private
     */
    _createWrapper: function (parentCurrent) {
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Признак того что значение ячейки изменилось
    * @since 5.5.0.1000
    * @method WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor#isValueChanged
    */
    isValueChanged: function () {
      var me = this;
      var values = me.serializeValue();
      //if (!me._value) me._value = null; //Шамов А.: Убрал, что бы осталась совместимость метода getValue, который должен вернуть пустую строку.


      if (me._value != values.value) {
        me._value = values.value;
        return true;
      }
      return false
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Метод вызывается когда значение в ячейке изменилось, и передает данные из
    * редактора в набор данных грида.
    * @since 5.5.0.1000
    * @method WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor#applyValue
    */
    applyValue: function (row, newData) {
      var me = this;
      me._updateData(row, newData);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Метод вызывается когда значение в ячейке изменилось, и передает данные из
    * редактора в набор данных грида.
    * @since 5.5.0.1000
    * @method WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor#serializeValue
    */
    serializeValue: function () {

      var me = this;
      var control = me._getWrapper();

      return {
        'value': control.getValue(),
        'displayValue': control.getDisplayValue()
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Очистка поля
     * @method WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor#destroy
     * @since 5.5.0.1000     
     */
    destroy: function () {
      var me = this;
      if ($('.rs_container').is(':visible').length) {
        me._jInput.HideContainer();
      }
      me._super();
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

})(window.WA.components.dataViews.gridPlugins._editors)